export const eventDetails = () => {
  return {
    ibadan: {
      date: "Tuesday, January 28, 2025",
      time: "10:00 AM",
      venue:
        "Ibadan Business School, Off Awolowo Ave, Behind Davis Hotel, Old Bodija, Ibadan",
      flyerUrl:
        "https://res.cloudinary.com/bacf/image/upload/v1737151509/Eraconneckt/1737144860370_lpf9xz.png",
      mapLink:
        "https://www.google.com/maps/place/Ibadan+Business+School/@7.401323,-3.901862,17z",
    },
    kumasi: {
      date: "Thursday, February 6, 2025",
      time: "10:00 AM",
      venue: "SRC Conference Hall, Kumasi Technical University, Ghana",
      flyerUrl:
        "https://res.cloudinary.com/bacf/image/upload/v1737463546/Eraconneckt/Image_bwmkyv.jpg",
      mapLink:
        "https://www.google.com/maps/place/Kumasi+Technical+University/@6.6864304,-1.612063,17z",
    },
    generalInfo: {
      title: "Digital Skills, Limitless Future",
      subTitle: "Eraconneckt OpenForum 2025",
      description: `<p>The world is evolving rapidly, and digital skills have become the foundation for innovation, economic growth, and personal empowerment. In an era where technology shapes industries and opportunities, acquiring digital expertise is no longer optional-it is essential.</p><p>Hosted by <strong>Eraconneckt</strong>, this event is set to take place in two vibrant locations-<strong>Ghana and Ibadan</strong>-bringing together industry leaders, digital professionals, and passionate individuals who are eager to explore the limitless potential of the digital world.</p><h3>Why You Should Attend</h3><ul><li><strong>💼 Job Fair! </strong>Are you ready to advance your career paths and unlock new career opportunities? Connect with top recruiters and industry experts as they share insights about the labour market.</li><li><strong>🌍 Bridging the Digital Gap</strong>In Africa, digital transformation is creating incredible opportunities, but access to digital skills remains a challenge for many. This event is designed to close that gap by providing hands-on training, insightful discussions, and valuable mentorship.</li><li><strong>🚀 Empowering the Next Generation</strong>This is more than just an event; it is a movement toward a brighter, technology-driven future. We are committed to equipping young minds with the skills that will enable them to secure global opportunities, build innovative businesses, and transform their communities.</li></ul>`,
    },
  };
};

export const eventSpeakersData = [
  {
    id: 0,
    imgSrc:
      "https://res.cloudinary.com/bacf/image/upload/v1734029110/HRTechish/speaker_n3gcrx.jpg",
    speakerName: "Bashirat Are",
    role: "CEO",
    organization: "BACF",
  }
];
